import React, { useState, useEffect, useRef } from 'react'

import LazyLoad from 'react-lazy-load'
import { useSelector, shallowEqual } from 'react-redux'
import { Redirect } from 'react-router-dom'
import styled from 'styled-components'

import { SimpleCarousel } from '.'
import { BreadCrumbs } from '..'
import { useEventListener, useWindowSize } from '../../_helpers'
import {
    Container,
    Meta,
    devices,
    colors,
    Number,
} from '../Common'
import { Loading } from '../Global/Loading'

const ImageCard = ({ image, openModal, index, width, mobile, showNumbers }) => {
    const columns = mobile ? 2 : 3
    const thumbWidth = Math.round((width / columns) - 23)
    const [height, setHeight] = useState(0)
    const [opacity, setOpacity] = useState(0)

    let img = new Image()
    img.src = image.image
    img.onload = () => setHeight((img.height / img.width) * thumbWidth)

    useEffect(() => {
        if (height > 0) setTimeout(() => setOpacity(1), 500)
    }, [height])

    return (
        <ImageContainer opacity={opacity} height={height} src={image.image} alt={image.alt_text} once>
            <TextContainer onClick={openModal}>
                {showNumbers && <ImageText>
                    <Number>{index + 1}</Number><br />
                    {image.description || 'Description'}
                </ImageText>}
            </TextContainer>
        </ImageContainer>
    )
}


const PageView = () => {
    const { page, notFound } = useSelector(state => state.content, shallowEqual)
    const { gallery, title } = page

    const [showLightBox, setShowLightBox] = useState(false)
    const [activeSlide, setactiveSlide] = useState(0)
    const { width } = useWindowSize()
    const mobile = width < 480
    const container = useRef()
    const [containerWidth, setContainerWidth] = useState('')

    const openModal = i => {
        setactiveSlide(i)
        window.scrollTo(0, 0)
        document.getElementById('main').scrollTop = 0
        setShowLightBox(true)
    }

    const closeModal = () => setShowLightBox(false)
    useEffect(closeModal, [page])

    if (notFound) return <Redirect to='/' />

    useEffect(() => {
        if (container) setContainerWidth(container.current.offsetWidth)
    }, [container])

    useEventListener('resize', () => setContainerWidth(container.current.offsetWidth))

    return (
        <>
            <Meta page={page} />
            <PageContainer ref={container} lightbox={showLightBox}>
                {gallery ?
                    showLightBox ?
                        <SimpleCarousel slides={gallery} close={closeModal} activeImage={activeSlide} title={title} mobile={mobile} />
                        :
                        <>
                            {title && <BreadCrumbs title={title} mobile={mobile} />}
                            <ImageList>
                                {gallery.map((image, i) =>
                                    <ImageCard
                                        key={i}
                                        image={image}
                                        index={i}
                                        width={containerWidth}
                                        openModal={() => openModal(i)}
                                        mobile={mobile}
                                        showNumbers={page.url.includes('rentals')}
                                    />
                                )}
                            </ImageList>
                        </>
                    : <Loading marginbottom={30} />}
            </PageContainer>
        </>
    )
}

const PageContainer = styled(Container)`
    ${({ lightbox }) => lightbox && `
        padding-left: 0;
        padding-right: 0;
    `}

    min-height: calc(100vh - 90px);
    @media ${devices.small} {
        min-height: 95vh;
    }
`

const ImageList = styled.div`
   column-count: 3;
   column-gap: 6px;

    @media ${devices.small} {
        column-count: 2;
        column-gap: 6px;
    }
`

const TextContainer = styled.div`
    height: 100%;
    cursor: pointer;
    background: transparent;
    color: ${colors.white};
    position: relative;
    text-shadow: 0 1px 1px #000000;
`

const ImageText = styled.div`
    position: absolute;
    bottom: 0;
    padding: 14px;
    font-size: 13px;

    div {
        font-weight: 900;
        margin-bottom: 3px;
        font-size: 16px;
        @media ${devices.small} {
            font-size: 13px;
        }
    }

    @media ${devices.small} {
        font-size: 11px;
        padding: 7px;
    }

`

const ImageContainer = styled.div`
    width: calc(100% - 18px);
    margin-bottom: 10px;
    transition: opacity 0.3s ease-in;
    opacity: ${props => props.opacity};
    border: 7px solid white;
    background: url(${props => props.src}) center/cover no-repeat;
    page-break-inside: avoid;
    break-inside: avoid;
    display: inline-block;

    @media ${devices.small} {
        border-width: 3px;
        width: calc(100% - 9px);
        /* margin-bottom: 5px; */
    }
`

export default PageView
